import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'tentStripe',
      d: 'M-0.5,-3.5h0.5v1.5h-0.5zM-1,-2h1v1.5h-1zM-4,-0.5h0.5v0.5h-0.5zM-0.5,-0.5h4v0.5h-4zM-3.5,0h6v0.5h-6zM0,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['sail', 0.22],
        ['tent', 0.78],
      ],
      d: 'M-1,-6h0.5v0.5h-0.5zM-1,-5.5h1v0.5h-1zM-1.5,-5h1.5v0.5h-1.5zM-1.5,-4.5h0.5v0.5h-0.5zM-2,-4h1v1h-1zM0,-3.5h0.5v2h-0.5zM-2.5,-3h1v0.5h-1zM-3,-2.5h1.5v0.5h-1.5zM-3,-2h1v0.5h-1zM-3.5,-1.5h1.5v1h-1.5zM0,-1.5h1v0.5h-1zM0.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['tent', 0.76],
      ],
      d: 'M-0.5,-6.5h1v0.5h-1zM-0.5,-6h2v0.5h-2zM0,-5.5h2v1h-2zM-2,-4.5h0.5v0.5h-0.5zM-1,-4.5h3v0.5h-3zM-0.5,-4h3v0.5h-3zM0.5,-3.5h2v0.5h-2zM-1.5,-3h0.5v0.5h-0.5zM0.5,-3h2.5v1h-2.5zM-2,-2h0.5v1h-0.5zM0.5,-2h3v0.5h-3zM1,-1.5h2.5v1h-2.5zM0,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v0.5h-0.5z',
    },
    { paint: 'shadow', d: 'M-1,-3.5h0.5v0.5h-0.5zM-1.5,-2.5h0.5v1.5h-0.5zM-2,-1h1v1h-1z' },
    {
      paint: 'fence',
      d: 'M-1,-7.5h1v1h-1zM-1,-6.5h0.5v0.5h-0.5zM-1.5,-6h0.5v1h-0.5zM1.5,-6h0.5v0.5h-0.5zM-2,-5h0.5v0.5h-0.5zM2,-5h0.5v1h-0.5zM-2.5,-4h0.5v0.5h-0.5zM2.5,-4h0.5v1h-0.5zM-3,-3.5h1v0.5h-1zM-3,-3h0.5v0.5h-0.5zM3,-3h0.5v1h-0.5zM-3.5,-2.5h0.5v1h-0.5zM3.5,-2h0.5v1h-0.5zM-4,-1.5h0.5v1h-0.5zM3.5,-1h1v0.5h-1zM-4.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1,-4h0.5v0.5h-0.5zM-1,-3h0.5v1h-0.5zM-5,-0.5h0.5v0.5h-0.5zM-1,-0.5h0.5v0.5h-0.5zM4,-0.5h1v1h-1zM-5,0h1v0.5h-1z',
    },
  ],
  pixels: 175,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
